import { ForwardIcon } from '@heroicons/react/24/solid';
import { MediaSeekForwardButton } from 'media-chrome/react';
import { CSSProperties } from 'react';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';

import { defaultButtonStyling } from './util';

interface Props {
  disabled?: boolean;
}

export function PlayerSeekForwardButton({ disabled = false }: Props) {
  return (
    <div>
      <MediaSeekForwardButton
        style={
          {
            '--media-control-background': 'transparent',
            '--media-control-hover-background': 'transparent',
            ...defaultButtonStyling,
          } as CSSProperties
        }
        seekOffset={10}
        disabled={disabled}
      >
        <span slot="icon">
          <Button aria-hidden="true" tabIndex={-1} variant="ghost" size="md">
            <HeroIcon icon={ForwardIcon} />
          </Button>
        </span>
      </MediaSeekForwardButton>
    </div>
  );
}
